import { Link } from "react-router-dom";
import { Mail, Phone, Sparkles, Lock } from "lucide-react";
import Logo from "./Logo";
import LanguageToggle from "./LanguageToggle";
import { BRAND, NAV_LINKS } from "../lib/brand";
import { useI18n } from "../i18n/I18nContext";

export default function SiteFooter() {
  const { lang } = useI18n();
  return (
    <footer className="bg-charcoal-900 dark-surface">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid md:grid-cols-12 gap-10 text-white/70">
        <div className="md:col-span-5">
          <Logo dark variant="full" to="/" />
          <p className="mt-5 text-sm text-white/60 max-w-sm leading-relaxed">
            {lang === "en"
              ? "Nail Viet Club is the business community for Vietnamese nail professionals — events, education, AI, business resources, and networking."
              : "Nail Viet Club là cộng đồng kinh doanh dành cho người làm nail Việt Nam — sự kiện, đào tạo, AI, tài nguyên kinh doanh và networking."}
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-gold-300 font-semibold">
            <Sparkles className="w-3.5 h-3.5" />
            {lang === "en" ? BRAND.taglineEn : BRAND.taglineVi}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] uppercase tracking-[0.28em] text-gold-300 font-semibold mb-3">{lang === "en" ? "Platform" : "Nền tảng"}</p>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-white/70 hover:text-white">{lang === "en" ? l.en : l.vi}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] uppercase tracking-[0.28em] text-gold-300 font-semibold mb-3">{lang === "en" ? "Get in touch" : "Liên hệ"}</p>
          <a
            href={`tel:${BRAND.phone}`}
            data-testid="footer-phone"
            className="inline-flex items-center gap-2 border border-gold-500/40 bg-white/5 rounded-full px-4 py-2 text-sm text-white hover:bg-white/10 transition-all w-full justify-start"
          >
            <Phone className="w-4 h-4 text-gold-300" />
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[9px] uppercase tracking-[0.22em] text-gold-300 font-semibold">
                {lang === "en" ? "AI Voice · Toll-free 24/7" : "Cố Vấn AI · Miễn phí 24/7"}
              </span>
              <span className="font-mono">{BRAND.phoneDisplay}</span>
            </span>
          </a>
          <a href={`mailto:${BRAND.email}`} className="mt-2.5 inline-flex items-center gap-2 border border-white/20 rounded-full px-4 py-2 text-sm text-white hover:bg-white/10 transition-all" data-testid="footer-contact">
            <Mail className="w-4 h-4" /> {BRAND.email}
          </a>
          <div className="mt-4"><LanguageToggle variant="dark" /></div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {new Date().getFullYear()} {BRAND.name}. {BRAND.domain}</span>
          <div className="flex items-center gap-4">
            <Link
              to="/admin/login"
              data-testid="footer-admin-login"
              className="inline-flex items-center gap-1.5 text-white/60 hover:text-gold-300 uppercase tracking-[0.22em] font-semibold transition"
              title={lang === "en" ? "Organizer / admin sign in" : "Đăng nhập tổ chức / admin"}
            >
              <Lock className="w-3 h-3" />
              {lang === "en" ? "Organizer sign in" : "Đăng nhập tổ chức"}
            </Link>
            <span className="uppercase tracking-[0.24em] text-gold-300/80 font-semibold" data-testid="powered-by">Powered by AsterPOS Corp</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
